import React from 'react';
import { Drawer } from '../../packages/ui';
import { AccountPanel, NavLinks } from './Sidebar';

/**
 * Navigation at ≤768px: the full sidebar content in a modal Drawer (U11), so
 * focus is contained, Escape and the close button work, and focus returns to
 * the menu button on close. Following a link closes it.
 */
export function MobileDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
    return (
        <Drawer open={open} onClose={onClose} title="Menu" side="left" className="shell-drawer">
            <div className="sidebar-navs">
                <NavLinks onNavigate={onClose} />
            </div>
            <AccountPanel onNavigate={onClose} />
        </Drawer>
    );
}
